/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import logo from "./customer-aledade.png";
import Company from "./company";
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      p: "p",
      strong: "strong",
      a: "a",
      em: "em",
      blockquote: "blockquote"
    }, props.components), {Header} = _components;
    if (!Header) _missingMdxReference("Header", true);
    return _jsxs(_Fragment, {
      children: [_jsxs("article", {
        children: [_jsx(Header, {}), _jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: "My day job:"
          }), " Democratizing data access for others at my company. But I volunteered in 2020 to have a twin focus on climate. So one moment I’m handling SQL queries and the next I’m asking how we can help ", _jsx(_components.a, {
            href: "https://resources.aledade.com/aco-show-podcasts/episode-98-turning-your-practice-green",
            children: "primary care physicians switch to clean energy"
          }), "."]
        }), _jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: "My climate background:"
          }), " I didn’t take any environmental classes in college. I just didn’t see how I had an opportunity to make a difference. But it turns out the corporate world is full of opportunities. And the more I invested into understanding them, the more my ambition for Aledade’s climate program grew, and the more trust I was given."]
        }), _jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: "I’m proud of:"
          }), " Over just the last year, we gained a granular understanding of our emissions, achieved ", _jsx(_components.a, {
            href: "https://resources.aledade.com/press-releases/aledade-announces-carbon-neutrality-additional-sustainability-efforts",
            children: "carbon neutrality"
          }), ", and began switching over to clean energy. And we’re now already increasing our carbon removal investments ", _jsx(_components.em, {
            children: "by 6-7x"
          }), ". This is progress that used to take companies several years."]
        }), _jsxs(_components.p, {
          children: [_jsx(_components.strong, {
            children: "I want others to know:"
          }), " You can do this work too! We started our climate program with zero expertise and just an inkling of an idea. There’s a whole community of people out there willing to collaborate, and teams like Watershed to help you navigate the unknowns."]
        })]
      }), "\n", _jsxs(Company, {
        name: "Aledade",
        logo: logo,
        children: [_jsx(_components.p, {
          children: "Keeping people healthier and out of hospitals—the second most energy-intensive building type in the US."
        }), _jsx(_components.p, {
          children: "Created a best-in-class carbon removal portfolio before other companies were thinking about it."
        })]
      }), "\n", _jsxs(_components.blockquote, {
        children: ["\n", _jsxs(_components.p, {
          children: ["Most companies are now realizing that ", _jsx("mark", {
            children: "climate work is aligned with their mission and long-term goals"
          }), "."]
        }), "\n"]
      })]
    });
  }
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
